import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { DatePipe } from '@angular/common';
import { io } from 'socket.io-client';

@Component({
  selector: 'app-initial-interest',
  templateUrl: './initial-interest.component.html',
  styleUrls: ['./initial-interest.component.css']
})
export class InitialInterestComponent implements OnInit {

  isDisplayCalculate = true;
  isDisplayResule = false;
  operators = ['สมาคม (โครงการในพื้นที่เป้าหมาย)',
    'สมาคม (โครงการนอกพื้นที่เป้าหมาย)',
    'องค์กรปกครองส่วนท้องถิ่น',
    'การเคหะแห่งชาติ',
    'กรมโยธาธิการและผังเมือง',
    'หน่วยงานของรัฐหรือนิติบุคคลที่รัฐตั้งขึ้นเพื่อการจัดรูปที่ดิน',
    'หน่วยงานของรัฐอื่นตามที่กำหนดในกฎกระทรวง'
  ];
  years = [0, 1, 2];
  data_cal = {
    area: '',
    operator: '',
    creator: '',
    interest: 0,
    budget: '',
    loan_date: '',
    loan_length: '',
    principle_gp: '',
    interest_gp: ''
  };
  data_budget: any;
  data_date: any;
  date_today = new Date().toLocaleDateString('th-TH', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
  data_con: any;
  principle: any;
  amount: any;
  datestart: any;
  yearstart: any;
  latest_amount: any;
  calculates = [] as any;
  sum_interest: any = 0;
  sum_principle: any = 0;
  sum_sum: any = 0;
  visitor: any = [];
  socket: any;

  constructor(public services: ApiService) { }

  ngOnInit(): void {
    this.services.get('m_calconditions').then((res: any) => {
      this.getData(res[0]);
    });
    // this.socket = io('https://ogc.mapedia.co.th/api/v2/lrfund/');
    this.services.get('m_countofuser').then((res: any) => {
      this.getCounter(res);
    })
    // this.socket.on('output', (res: any) => {
    //   this.getCounter(res);
    // });
  }
  getData(data: any) {
    data.date_declare_th = this.dateThai(data.date_declare)
    data.date_used_th = this.dateThai(data.date_used)
    this.data_con = data;
  }

  select_operator(ev: any) {
    this.data_con.interest = parseFloat(this.data_con.interest).toFixed(3);
    switch (this.data_cal.operator) {
      case 'สมาคม (โครงการในพื้นที่เป้าหมาย)': {
        this.data_cal.interest = this.data_con.interest - 3.5;
        break;
      }
      case 'สมาคม (โครงการนอกพื้นที่เป้าหมาย)': {
        this.data_cal.interest = this.data_con.interest - 2;
        break;
      }
      case 'องค์กรปกครองส่วนท้องถิ่น': {
        this.data_cal.interest = this.data_con.interest - 3;
        break;
      }
      case 'การเคหะแห่งชาติ': {
        this.data_cal.interest = this.data_con.interest - 3;
        break;
      }
      case 'กรมโยธาธิการและผังเมือง': {
        this.data_cal.interest = this.data_con.interest - 3;
        break;
      }
      case 'หน่วยงานของรัฐหรือนิติบุคคลที่รัฐตั้งขึ้นเพื่อการจัดรูปที่ดิน': {
        this.data_cal.interest = this.data_con.interest - 2;
        break;
      }
      case 'หน่วยงานของรัฐอื่นตามที่กำหนดในกฎกระทรวง': {
        this.data_cal.interest = (this.data_con.interest - 2);
        break;
      }
      default: {
        // console.log('selected not found');
        break;
      }
    }
  }

  calculater(form: any) {
    this.calculates = [];
    this.sum_interest = 0;
    this.sum_principle = 0;
    this.sum_sum = 0;
    this.data_budget = this.data_cal.budget;
    this.data_date = this.dateThai(this.data_cal.loan_date)
    var date = new Date(this.data_cal.loan_date);
    var splitted: any;
    var day: any
    var month: any
    var year: any
    let data_now: any;

    this.principle = (Math.round(((parseInt(this.data_cal.budget) / (parseInt(this.data_cal.loan_length) - parseInt(this.data_cal.principle_gp))) + Number.EPSILON) * 100) / 100);
    this.amount = parseInt(this.data_cal.budget);
    this.latest_amount = parseInt(this.data_cal.budget);

    for (let i = 1; i < parseInt(this.data_cal.loan_length) + 1; i++) {
      if (i == 1) {
        data_now = this.dateThai(new DatePipe('en-US').transform((date.setDate(date.getDate() + 364)), 'MM-dd-yyyy'))
        splitted = data_now.split(" ");
        day = splitted[0]
        month = splitted[1]
        year = splitted[2]
      } else {
        data_now = `${day} ${month} ${parseInt(year) + 1}`
        year = parseInt(year) + 1
      }
      if (i > parseInt(this.data_cal.principle_gp) + 1) {
        this.amount = this.latest_amount
      }
      if (i <= parseInt(this.data_cal.principle_gp) && i <= parseInt(this.data_cal.interest_gp)) {
        this.calculates.push({
          date: data_now,
          amount: this.amount,
          loan_rate: 0,
          interest: 0,
          principle: 0,
          sum: 0,
          interestN: 0,
          principleN: 0,
          sumN: 0
        })
      } else if (i <= parseInt(this.data_cal.principle_gp)) {
        this.calculates.push({
          date: data_now,
          amount: this.amount,
          loan_rate: this.data_cal.interest,
          interest: (Math.round(((this.amount * (this.data_cal.interest / 100)) + Number.EPSILON) * 100) / 100),
          principle: 0,
          sum: (Math.round((((this.amount * (this.data_cal.interest / 100))) + Number.EPSILON) * 100) / 100),
          interestN: (Math.round(((this.amount * (this.data_cal.interest / 100)) + Number.EPSILON) * 100) / 100),
          principleN: 0,
          sumN: (Math.round((((this.amount * (this.data_cal.interest / 100))) + Number.EPSILON) * 100) / 100)
        })
      } else if (i <= parseInt(this.data_cal.interest_gp)) {
        this.calculates.push({
          date: data_now,
          amount: this.amount,
          loan_rate: 0,
          interest: 0,
          principle: parseFloat(this.principle),
          sum: (Math.round((parseFloat(this.principle) + Number.EPSILON) * 100) / 100),
          interestN: 0,
          principleN: parseFloat(this.principle).toFixed(2),
          sumN: (Math.round((parseFloat(this.principle) + Number.EPSILON) * 100) / 100)
        })
      } else {
        this.calculates.push({
          date: data_now,
          amount: this.amount,
          loan_rate: this.data_cal.interest,
          interest: (Math.round(((this.amount * (this.data_cal.interest / 100)) + Number.EPSILON) * 100) / 100),
          principle: parseFloat(this.principle),
          sum: (Math.round(((parseFloat(this.principle) + (this.amount * (this.data_cal.interest / 100))) + Number.EPSILON) * 100) / 100),
          interestN: (Math.round(((this.amount * (this.data_cal.interest / 100)) + Number.EPSILON) * 100) / 100),
          principleN: parseFloat(this.principle),
          sumN: (Math.round(((parseFloat(this.principle) + (this.amount * (this.data_cal.interest / 100))) + Number.EPSILON) * 100) / 100)
        })
      }
      this.latest_amount = this.amount - parseInt(this.principle);
    }
    this.calculates.forEach((res: any) => {
      this.sum_interest += (Math.round(((parseFloat(res.interestN)) + Number.EPSILON) * 100) / 100);
      this.sum_principle += (Math.round(((parseFloat(res.principleN)) + Number.EPSILON) * 100) / 100)
      this.sum_sum += (Math.round(((parseFloat(res.sumN)) + Number.EPSILON) * 100) / 100)
    });
    // this.sum_interest = (Math.round(((this.sum_interest) + Number.EPSILON) * 100) / 100);
    // this.sum_principle = (Math.round(((this.sum_principle) + Number.EPSILON) * 100) / 100);
    // this.sum_sum = (Math.round(((this.sum_sum) + Number.EPSILON) * 100) / 100);
    this.isDisplayCalculate = false;
    this.isDisplayResule = true;
    document.querySelector('#target')!.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  close() {
    this.isDisplayCalculate = true;
    this.isDisplayResule = false;
    document.querySelector('#target')!.scrollIntoView({ behavior: 'smooth', block: 'start' });
    this.data_cal = {
      area: '',
      operator: '',
      creator: '',
      interest: 0,
      budget: '',
      loan_date: '',
      loan_length: '',
      principle_gp: '',
      interest_gp: ''
    };
  }

  reset(form?: any) {
    form.reset();
  }

  numberWithCommas(number: any) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  }
  dateThai(date: any) {
    var newDate = new Date(date).toLocaleDateString('th-TH', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
    return newDate;
  }
  async getCounter(data: any) {
    let counnt_visitor = (data.length).toString()
    this.visitor = [];
    for (let j = 0; j < counnt_visitor.length; j++) {
      this.visitor.push(counnt_visitor[j])
    }
    for (let x = 0; x < 6; x++) {
      if (this.visitor.length < 6) {
        this.visitor.splice(0, 0, 0);
      }
    }
  }
}
